import React from 'react';
import './style.scss';
import '../style.scss';
import vnptLogo from "assets/imgs/QrCodeMyVnptVer2/logo-footer.png";
import picLogo from "assets/imgs/QrCodeMyVnptVer2/pic-logo.png";
import geoTrustLogo from "assets/imgs/QrCodeMyVnptVer2/geo-trust.png";
import rectangleImg from "assets/imgs/QrCodeMyVnptVer2/rectangleImg.png";

const Footer = () => {
  return (
    <div id="qr-code__footer-v2">
      <img src={vnptLogo} alt="vnptLogo" />
      <div className="qr-code__footer--logo">
        <span className="qr-code__footer--txt">Một sản phẩm của VNPT</span>
      </div>
      <div className="qr-code__footer--info">
        <div className="qr-code__footer--info-cc">
          <div className="qr-code__footer--txt">Chứng chỉ bảo mật</div>
          <div className="qr-code__footer--info-logo">
            <div className='mb-12'><img src={geoTrustLogo} alt="geoTrustLogo" /></div>
            <div className='mb-2'><img src={picLogo} alt="picLogo" /></div>
          </div>
        </div>

        <div className='rectangle'><img src={rectangleImg} alt="" /></div>

        <div className="qr-code__footer--info-help">
          <div className="qr-code__footer--txt">Hotline hỗ trợ: </div>
          <a href='tel:1800 1091' className="qr-code__footer--sub-txt">1800 1091 <span>(nhánh 3)</span></a>
          <a href="https://vnptpay.vn/web/trogiup/chinhsach_vietqr" className="qr-code__footer--txt text-underline text-itatlic">Điều khoản sử dụng</a>
        </div>
      </div>

    </div>
  );
}

export default React.memo(Footer);
